import { modifier } from 'ember-modifier';
import { scheduleTask, throttleTask, cancelTask } from 'ember-lifeline';

export default modifier(function chatScroll(element, [setUserScrolledUp]) {
  let userIsScrolledUp = false;
  let throttleActionId = null;
  this.rawScrollHandler = () => {
    const userIsAtBottom =
      Math.abs(
        element.scrollHeight - element.scrollTop - element.clientHeight,
      ) <= 100;
    // Condition 1: User was scrolled up and now reached the bottom
    if (userIsScrolledUp && userIsAtBottom) {
      userIsScrolledUp = false;
      setUserScrolledUp(false); // Flip state and  Notify component
    }

    // Condition 2: User was at the bottom (or not explicitly scrolled up) and now scrolled away from the bottom
    else if (!userIsScrolledUp && !userIsAtBottom) {
      userIsScrolledUp = true;
      setUserScrolledUp(true); // Flip state and Notify component
    }
  };

  const throttledScrollHandler = () => {
    throttleActionId = throttleTask(this, 'rawScrollHandler', 100, false);
  };

  element.addEventListener('scroll', throttledScrollHandler);

  // Initial check: After render, determine initial scroll state
  // This is crucial for when content loads and the container might not be full,
  // or if content is pre-filled and the user is not at the very bottom initially.
  scheduleTask(this, 'actions', () => {
    const isAtBottomInitially =
      Math.abs(
        element.scrollHeight - element.scrollTop - element.clientHeight,
      ) <= 1;
    if (!isAtBottomInitially) {
      // If not at bottom initially, set userScrolledUp to true
      userIsScrolledUp = true;
      setUserScrolledUp(true);
    }
    // If it is at bottom initially, isUserScrolledUp remains false (correct)
  });

  // Teardown: Remove event listener when the modifier is removed
  return () => {
    element.removeEventListener('scroll', throttledScrollHandler);
    if (throttleActionId) cancelTask(this, throttleActionId);
  };
});
